import Spinner from 'components/Spinner'
import { useSelector } from 'react-redux'
import { getLoading } from 'state/Request'
import { klass } from 'utils'
import EmptyMessage from './EmptyMessage'

SpinnerFull.propTypes = {
	icon    : EmptyMessage.propTypes.icon,
	resource: EmptyMessage.propTypes.resource
}

/**
 * Similar in style to {@link EmptyMessage}, but shows a simple spinner with an icon and nothing else.
 * @param icon
 * @param resource {string} Any of {@link API.RESOURCES}
 * @param backdrop=false {boolean} If it should block UI interaction fullscreen, or just show as an usual block element
 * @todo backdrop=true was created to show a spinner when refreshing orders, but then it wouldn't work well because orders get refreshed under the hood whn reopening them, so this is unused, as of now. Make sure all behaviors are well covered if you try to use it!!
 * @return {JSX.Element}
 * @constructor
 */
export default function SpinnerFull({ icon, resource, backdrop = false }) {
	icon          = Spinner.simpleIcon(icon)
	const loading = useSelector(getLoading(resource))
	return <div {...klass('empty-area', { backdrop, loading })} style={{minHeight: 0}}>
		{loading && <Spinner icon={icon}/>}
	</div>
}
